import { useEffect, useState } from "react";

const CurrentDeviceSize = () => {
    const [deviceSize, setDeviceSize] = useState('');

    const handleResize = () => {
        const windowWidth = window.innerWidth;

        if (windowWidth <= 768) {
            setDeviceSize('Mobile');
        } else {
            setDeviceSize('Desktop');
        }
    };

    useEffect(() => {
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return deviceSize;
}

export default CurrentDeviceSize;
